<p-dialog
	[(visible)]="displayCart"
	[breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
	[style]="{ width: '50vw', height: '80vh' }"
	(onHide)="displayCartChange.emit(false); displayCart = false"
>
	<ng-template pTemplate="header">
		<div class="d-flex">
			<div class="h3">Checkout</div>
		</div>
	</ng-template>

	<p-accordion>
		<ng-container *ngFor="let item of checkoutSection; let index = index">
			<p-accordionTab [disabled]="item.disabled" [(selected)]="item.selected">
				<ng-container [ngSwitch]="item.value">
					<ng-template pTemplate="header">
						<div class="d-flex w-100">
							<div class="ms-2 display-10">{{ item.label }}</div>
							<div class="ms-auto">
								<fa-icon *ngIf="item.meta === 'complete'" [icon]="['far', 'check-double']" size="lg"></fa-icon>
							</div>
						</div>
					</ng-template>
					<ng-container *ngSwitchCase="'cart'">
						<app-checkout-cart></app-checkout-cart>
					</ng-container>
					<ng-container *ngSwitchCase="'bill'">
						<app-checkout-purchaser-info
							(formCompleteChange)="item.meta = 'complete'; evalCompletedFormSection(index)"
						></app-checkout-purchaser-info>
					</ng-container>
					<ng-container *ngSwitchCase="'ship'">
						<app-checkout-shipping-information
							(formCompleteChange)="item.meta = 'complete'; evalCompletedFormSection(index)"
						></app-checkout-shipping-information>
					</ng-container>
					<ng-container *ngSwitchCase="'payment'">
						<app-checkout-payment (formCompleteChange)="item.meta = 'complete'; evalCompletedFormSection(index)"></app-checkout-payment>
					</ng-container>
					<ng-container *ngSwitchCase="'confirmation'">
						<app-checkout-confirmation (formCompleteChange)="item.meta = 'complete'; evalCompletedFormSection(index)"></app-checkout-confirmation>
					</ng-container>
				</ng-container>
			</p-accordionTab>
		</ng-container>
	</p-accordion>
</p-dialog>
